//@ts-check
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  content: null,
  aiText: null,
  aiContext: null,
  tone: 'general',
};

const aiModalSlice = createSlice({
  name: 'aimodal',
  initialState,
  reducers: {
    setOpenModal: (state, action) => {
      state.isOpen = action.payload;
    },
    setContent: (state, action) => {
      state.content = action.payload;
    },
    setEditorValue: (state, action) => {
      state.aiText = action.payload;
    },
    setAiContext: (state, action) => {
      state.aiContext = action.payload;
    },
    setAiModelGenerate: (state, action) => {
      state.isOpen = action.payload.isOpen;
      state.content = action.payload.content;
      state.tone = action.payload.tone;
    },
    clearModel: () => initialState,
  },
});

export const getOpenModal = (state) => state.aimodal.isOpen;
export const getContent = (state) => state.aimodal.content;
export const getEditorValue = (state) => state.aimodal.aiText;
export const getAiContext = (state) => state.aimodal.aiContext;
export const getAiModelGenerate = (state) => state.aimodal;
export const {
  setOpenModal,
  setContent,
  setAiModelGenerate,
  setAiContext,
  setEditorValue,
  clearModel,
} = aiModalSlice.actions;

export default aiModalSlice.reducer;
